import { IntlShape } from 'react-intl';
import { Commodity } from '@enmon/commons/lib/shared';
import { Nullable } from '@enmon/commons';
import { SerialNumberTooltip as messages } from '../messages';

export const getSerialNumberTooltip = (commodity: Nullable<Commodity>, intl: IntlShape) => {
  if (!commodity) {
    console.warn('Received empty commodity: ', commodity);
    return undefined;
  }

  switch (commodity) {
    case Commodity.Electricity:
      return intl.formatMessage(messages.electricity);
    case Commodity.Water:
      return intl.formatMessage(messages.water);
    case Commodity.NaturalGas:
      return intl.formatMessage(messages.gas);
    default:
      return undefined;
  }
};
